import KakaoTalkButton from '@/components/feature/KakaoTalkButton';

export default function KakaoChatBanner() {
  return (
    <section className="w-full bg-white py-16 md:py-20 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          {/* Left: Text */}
          <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold mb-4" style={{ backgroundColor: '#FFF8E1', color: '#391B1B' }}>
              <i className="ri-kakao-talk-fill text-sm" style={{ color: '#391B1B' }}></i>
              실시간 1:1 상담
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 leading-tight">
              언제 어디서나 카카오톡으로
              <br />
              <span style={{ color: '#2E7D6B' }}>빠르고 편하게 상담</span>하세요
            </h2>
            <p className="text-sm text-gray-500 mb-6 leading-relaxed max-w-md">
              전화 상담이 어려우신가요? 카카오톡 채팅으로 간병 서비스, 보험 청구 서류, 등록 절차 등
              궁금한 모든 것을 실시간으로 문의하실 수 있습니다.
            </p>

            <div className="flex flex-wrap gap-4 mb-6 justify-center md:justify-start">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ backgroundColor: '#e8f5f1' }}>
                  <i className="ri-time-line text-sm" style={{ color: '#2E7D6B' }}></i>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-700">상담시간</p>
                  <p className="text-xs text-gray-500">오전 9시 ~ 오후 11시</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ backgroundColor: '#e8f5f1' }}>
                  <i className="ri-check-line text-sm" style={{ color: '#2E7D6B' }}></i>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-700">연중무휴</p>
                  <p className="text-xs text-gray-500">365일 상담 가능</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ backgroundColor: '#e8f5f1' }}>
                  <i className="ri-flashlight-line text-sm" style={{ color: '#2E7D6B' }}></i>
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-700">즉시 응답</p>
                  <p className="text-xs text-gray-500">평균 5분 내 응답</p>
                </div>
              </div>
            </div>

            <KakaoTalkButton
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm font-semibold whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#FEE500', color: '#391B1B' }}
              ariaLabel="카톡 상담 시작하기"
            >
              <i className="ri-kakao-talk-fill text-lg"></i>
              카톡 상담 시작하기
              <i className="ri-arrow-right-line ml-1"></i>
            </KakaoTalkButton>
          </div>

          {/* Right: Image */}
          <div className="w-full md:w-1/2">
            <div className="rounded-2xl overflow-hidden shadow-sm">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20Korean%20caregiver%20consulting%20with%20elderly%20patient%20family%20using%20smartphone%20messaging%20app%20in%20bright%20modern%20home%20setting%2C%20warm%20friendly%20atmosphere%2C%20clean%20minimalist%20interior%20with%20soft%20natural%20lighting%2C%20high%20quality%20photorealistic%2C%20green%20and%20white%20color%20tones&width=600&height=400&seq=kakaochat1&orientation=landscape"
                alt="카카오톡 상담"
                className="w-full h-64 md:h-80 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}